module.exports = __webpack_public_path__ + "img/drive_drive.7e4a4c43.svg";